module.exports = __webpack_public_path__ + "media/03.a5ec4974.mp4";